import { render, staticRenderFns } from "./popup-do-shang-pin.vue?vue&type=template&id=3ec929ab&scoped=true"
import script from "./popup-do-shang-pin.vue?vue&type=script&lang=js"
export * from "./popup-do-shang-pin.vue?vue&type=script&lang=js"
import style0 from "./popup-do-shang-pin.vue?vue&type=style&index=0&id=3ec929ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec929ab",
  null
  
)

export default component.exports